/**
 * Координация возврата с оплаты между вкладками.
 *
 * На вебе оплату открываем в ОТДЕЛЬНОЙ вкладке (см. paymentNavigation), чтобы
 * браузерный «назад» не ломал приложение. Вкладка оплаты (`/payment/success`)
 * после подтверждения платежа шлёт сигнал в главную вкладку через localStorage
 * (событие `storage` прилетает во ВСЕ остальные вкладки того же origin), а сама
 * закрывается. Главная вкладка ловит сигнал, обновляет баланс и — если ждали
 * оплату для генерации — продолжает создание песни.
 */
/** Ключ сигнала «оплата подтверждена» (значение уникально по времени). */
export const PAY_SUCCESS_SIGNAL_KEY = "tp_payment_success";
/**
 * true, если текущая вкладка — это открытая приложением вкладка оплаты
 * (у неё есть `window.opener`). В мини-аппах (внешний браузер) и при фолбэке
 * «в той же вкладке» opener отсутствует → false, и `/payment/success` работает
 * по старому сценарию (сам обновляет баланс / резюмит генерацию).
 */
export function isPaymentPopupContext() {
    try {
        return typeof window !== "undefined" && window.opener != null && window.opener !== window;
    }
    catch {
        // Кросс-ориджин доступ к opener мог кинуть — трактуем как «не попап».
        return false;
    }
}
/** Сообщить остальным вкладкам, что платёж подтверждён. */
export function signalPaymentSuccess(paymentId) {
    try {
        localStorage.setItem(PAY_SUCCESS_SIGNAL_KEY, `${paymentId}:${Date.now()}`);
    }
    catch {
        /* private mode / quota — молча */
    }
}
/** Снять сигнал (после обработки в главной вкладке). */
export function clearPaymentSuccessSignal() {
    try {
        localStorage.removeItem(PAY_SUCCESS_SIGNAL_KEY);
    }
    catch {
        /* no-op */
    }
}
